import { render, staticRenderFns } from "./ClientDetailsPortion.vue?vue&type=template&id=f96bfca4&"
import script from "./ClientDetailsPortion.vue?vue&type=script&lang=js&"
export * from "./ClientDetailsPortion.vue?vue&type=script&lang=js&"
import style0 from "./ClientDetailsPortion.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports